/* eslint camelcase: 0 */

import { File as Data } from '@/typings/api/File'
import { Model, createMessages } from '@/helpers/Model'


export class FileModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить файл',
    edit: 'Редактировать файл',
    view: (data: FileModel) => 'Файл «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Файлы',
  });

  public static readonly modal_delete = createMessages({
    ...Model.modal_delete,
    delete: (data: FileModel) => 'Удаление файла «{name}»'
      .replace('{name}', data.name || '...'),
  });
}
